/* SENS: explicit size selection, isolated from Minimog's automatic selection. */
(() => {
  'use strict';
  const states = new WeakMap();
  function chosen(picker, variants) {
    const radio = picker.querySelector('input[type="radio"]:checked');
    return radio ? variants.find(v => String(v.id) === radio.value) : undefined;
  }
  function initialize(picker) {
    if (states.has(picker)) return;
    const scope = picker.closest('.m-product-info--wrapper') || document;
    const form = [...scope.querySelectorAll('form')].find(f => f.getAttribute('id') === picker.dataset.formId);
    if (!form || form.dataset.sensSizeRequired !== 'true') return;
    const variants = JSON.parse(picker.querySelector('[data-sens-size-variants]').textContent);
    const id = form.querySelector('[name="id"]');
    const button = form.querySelector('[name="add"]');
    if (!id || !button) return;
    const state = { picker, variants, form };
    states.set(picker, state);
    function update(changeUrl = false) {
      const variant = chosen(picker, variants);
      id.value = variant ? String(variant.id) : '';
      id.disabled = !variant || !variant.available;
      button.disabled = !variant || !variant.available;
      button.classList.toggle('disabled', button.disabled);
      const text = !variant ? 'サイズを選択してください' : variant.available ? window.MinimogStrings?.addToCart || 'カートに追加' : window.MinimogStrings?.soldOut || '売り切れ';
      button.querySelector('.m-add-to-cart--text').textContent = text;
      picker.querySelector('[data-sens-size-label]').textContent = variant ? variant.option1 : 'サイズを選択してください';
      picker.querySelector('[data-sens-size-message]').textContent = !variant ? 'サイズを選択してからカートに追加してください。' : variant.available ? `選択したサイズ: ${variant.option1}` : 'このサイズは売り切れです。別のサイズをお選びください。';
      form.querySelectorAll('.m-product-dynamic-checkout').forEach(el => {
        el.hidden = !variant || !variant.available;
        el.toggleAttribute('data-sens-size-blocked', el.hidden);
      });
      if (variant && changeUrl && picker.closest('.m-main-product--info')) {
        const url = new URL(location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState(history.state, '', url);
      }
    }
    picker.addEventListener('change', () => update(true));
    window.addEventListener('pageshow', () => { if (picker.isConnected) update(); });
    update();
  }
  function scan() { document.querySelectorAll('[data-sens-size-picker]').forEach(initialize); }
  // Capture before theme/Folo handlers: neither Enter nor another submit path may bypass size selection.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.dataset?.sensSizeRequired !== 'true') return;
    const scope = form.closest('.m-product-info--wrapper') || document;
    const picker = [...scope.querySelectorAll('[data-sens-size-picker]')].find(p => p.dataset.formId === form.getAttribute('id'));
    const state = picker && states.get(picker);
    const variant = state && chosen(picker, state.variants);
    if (!variant?.available || form.querySelector('[name="id"]').value !== String(variant.id)) {
      event.preventDefault(); event.stopImmediatePropagation();
      picker?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      picker?.querySelector('input[type="radio"]')?.focus({ preventScroll: true });
    }
  }, true);
  scan();
  new MutationObserver(records => { if (records.some(r => r.addedNodes.length)) scan(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
